<form [formGroup]="getFormGroup()">

  <div class="item rounded freight-payer-grid p-2">
    <div class="row">
      <div class="p-2">
        <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
          Notification
        </div>
      </div>
    </div>
    <div formGroupName="email">
      <div class="row mb-1 m-2">
        <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="required-completion-date-input">Email Contact
          Name:</label>
        <div class="col-9">
          <input id="customer-reference-input" type="text" class="form-control required" formControlName="name"
            placeholder="Enter Email Contacts Name" />
        </div>
      </div>
      <div class="row mb-1 m-2">
        <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="required-completion-date-input">Contact Email
          Address:</label>
        <div class="col-9">
          <input id="customer-reference-input" type="text" class="form-control required" formControlName="address"
            placeholder="Enter Email Address" />
             @if(getFormGroup().get('email')?.get('address')?.invalid && getFormGroup().get('email')?.get('address')?.touched){
              <div class="text-start">
                <small class="text-danger">Please enter a valid email address</small>
              </div>
            }
        </div>
      </div>
    </div>
    <div formGroupName="mobile">
      <div class="row mb-1 m-2">
        <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="required-completion-date-input">Mobile Contact
          Name:</label>
        <div class="col-9">
          <input id="customer-reference-input" type="text" class="form-control required" formControlName="name"
            placeholder="Enter Mobile Contacts Name" />
        </div>
      </div>
      <div class="row mb-1 m-2">
        <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="required-completion-date-input">Mobile
          Number:</label>
        <div class="col-9">
          <input id="customer-reference-input" type="text" class="form-control required" formControlName="number"
            placeholder="Enter Mobile Number" />
        </div>
      </div>
    </div>
  </div>
</form>
